module.exports = __webpack_public_path__ + "static/media/9.f8692554.jpg";